module.exports = __webpack_public_path__ + "img/sleep.bbc55d4a.png";